module.exports = __webpack_public_path__ + "img/version-contract.64b89809.svg";